import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://fir-mlstiudio-91.firebaseio.com/'
});

export default instance;
